import { render, staticRenderFns } from "./ordersDeliveryPage.vue?vue&type=template&id=0fc500aa&"
import script from "./ordersDeliveryPage.vue?vue&type=script&lang=ts&"
export * from "./ordersDeliveryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports